import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import { DeviceSubTypeEnum } from "../../common/enums/DeviceSubTypeEnum";
import { DeviceTypesEnum } from "../../common/enums/DeviceTypesEnum";
import { ResourceTypeEnum } from "../../common/enums/ResourceTypeEnum";
import { TankLevelTransmitterTypeEnum } from "../../common/enums/TankLevelTransmitterTypeEnum";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { ITankStyleModel } from "../properties-data-service/Models";


export interface ITankPadModel {
    id: number;
    displayText: string;
    tankBatteries: Array<ITankBatteryModel>;
    tags: Array<ITagModel>;

    expanded?: boolean;
}


export interface ITankBatteryModel {
    id: number;
    displayText: string;
    devices: Array<IDeviceModel>;
    tanks: Array<ITankModel>;
    tankPadID: number;
    tags?: Array<ITagModel>;
    contractHour?: string;
    oilAllocationTAT?: ITatModel;
    waterAllocationTAT?: ITatModel;
    oilDisposalTAT?: ITatModel;
    waterDisposalTAT?: ITatModel;


    totalCapacity?: number;
    totalCapacityFilled?: string;
    dualPhase?: boolean;


}

export interface IDeviceModel {
    id: number;
    displayText: string;
    identifier: string | undefined;
    deviceTypeID: number | undefined;
    deviceSubTypeID: number | undefined;
    tankPadID: number;
    tankBatteryID: number;
    tags: Array<ITagModel>;
    contextGroupID?: number;
    href?: string;
    active?: boolean;
}

export interface ITankModel extends IDeviceModel {
    tankHeight: number;
    inchesMultiplier: number;
    tankOrder: number;
    capacity: number;
    dualPhase?: boolean;
}

export interface ITagModel {
    id: number;
    tagObjectID: number;
    tagObjectType: eLynxObjectTypeEnum;
    displayText: string;
    tagAssociationType: ITatModel;
    href?: string;
}

export interface ITatModel {
    id: number;
    displayText: string;
    name?: string;  // no consistency @@fix
}

export enum FilterTypeEnum {
    None = 0,
    TankPad = 1,
    TankBattery = 2,
    Device = 4,
    Tank = 8
}

export interface IFilterSettings {

    filterType: FilterTypeEnum;
    name?: string;
    capacityFilledOp?: string;
    capacityFilled?: number;
    BOPDOp?: string;
    BOPD?: number;
    BWPDOp?: string;
    BWPD?: number;
}

export interface ITankRelationshipExportOptions extends IFilterSettings {
    mimeType: ApplicationMimeTypesEnum;
    notificationKey: string;
}



export interface IAddDeviceModel extends IeLynxObject {
    deviceTypeEnum?: DeviceTypesEnum;
    deviceSubTypeEnum?: DeviceSubTypeEnum;
    isSelected?: boolean;
    isVisible?: boolean;
    resourceType?: ResourceTypeEnum;
    contractHour?: string;
}

export interface IAddTankModel extends IAddDeviceModel {
    tankStyle: ITankStyleModel
    transmitterType: TankLevelTransmitterTypeEnum;

}
